import React from "react";
import { resolveImageSrc } from "../utils/resolveImageSrc";
import "../style/component/MembersGrid.css";

function MembersGrid({ members = [], currentLanguage = "vi" }) {
  const isEnglish = currentLanguage === "en";
  const updatingText = isEnglish ? "Updating" : "Đang cập nhật";
  const roleLabel = isEnglish ? "Position at VietQubit:" : "Vai trò tại VietQubit:";
  const organizationLabel = isEnglish ? "Affiliation" : "Đơn vị công tác:";
  const researchLabel = isEnglish ? "Research interests" : "Lĩnh vực nghiên cứu:";
  const websiteLinkText = isEnglish ? "Access here" : "Truy cập tại đây";

  if (members.length === 0) {
    return (
      <div className="members-grid">
        <div className="member-card">
          <div className="member-image-container">
            <div className="member-placeholder-image">
              <span>{updatingText}</span>
            </div>
          </div>
          <div className="member-info">
            <h3 className="member-name">{updatingText}</h3>
            <ul className="member-details">
              <li>
                <span className="label">{roleLabel}</span>
                <span className="value">{updatingText}</span>
              </li>
              <li>
                <span className="label">{organizationLabel}</span>
                <span className="value">{updatingText}</span>
              </li>
              <li>
                <span className="label">{researchLabel}</span>
                <span className="value">{updatingText}</span>
              </li>
              <li>
                <span className="label">Email:</span>
                <span className="value">{updatingText}</span>
              </li>
              <li>
                <span className="label">Website:</span>
                <span className="value">{updatingText}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="members-grid">
      {members.map((member, index) => (
        <div className="member-card" key={member.id || index}>
          <div className="member-image-container">
            <img
              src={resolveImageSrc(member.image) || resolveImageSrc("/images/members_list/default.jpg")}
              alt={member.name || "Member"}
              className="member-image"
            />
          </div>
          <div className="member-info">
            <h3 className="member-name">{member.name || updatingText}</h3>
            <ul className="member-details">
              <li>
                <span className="label">{roleLabel}</span>
                <span className="value">{member.role || updatingText}</span>
              </li>
              <li>
                <span className="label">{organizationLabel}</span>
                <span className="value">{member.organization || updatingText}</span>
              </li>
              <li>
                <span className="label">{researchLabel}</span>
                <span className="value">{member.research || updatingText}</span>
              </li>
              <li>
                <span className="label">Email:</span>
                <span className="value">{member.email ? <a href={`mailto:${member.email}`}>{member.email}</a> : updatingText}</span>
              </li>
              <li>
                <span className="label">Website:</span>
                <span className="value">
                  {member.website ? (
                    <a href={member.website} target="_blank" rel="noreferrer">
                      {websiteLinkText}
                    </a>
                  ) : (
                    updatingText
                  )}
                </span>
              </li>
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MembersGrid;
